<div class="dozenten-page">
  <!-- Header mirrors the faqs / placements convention — `.header` +
       inner `<div>` + `<h2>` + `<p class="subtitle">`. Color / line
       height for the subtitle comes from the global rule in
       `styles.scss` (see design.md §"Hint Text on Page Background"). -->
  <div class="header">
    <div>
      <h2>{{ 'pages.dozenten.title' | translate }}</h2>
    </div>
    <app-page-help>{{ 'pages.dozenten.subtitle' | translate }}</app-page-help>
  </div>

  <div class="dozenten-grid">
    <!-- Left: list of dozent-bots -->
    <nb-card class="list-card">
      <nb-card-header>{{ 'pages.dozenten.list' | translate }}</nb-card-header>
      <nb-card-body>
        <ul class="dozent-list" *ngIf="dozents.length; else emptyList">
          <li
            *ngFor="let d of dozents"
            [class.is-selected]="selectedDozent?.id === d.id"
            (click)="selectDozent(d)"
          >
            <div class="dozent-list__name">{{ d.name }}</div>
            <small class="dozent-list__owner" *ngIf="d.created_by_name">
              {{ 'pages.dozenten.createdBy' | translate }} {{ d.created_by_name }}
            </small>
          </li>
        </ul>
        <ng-template #emptyList>
          <p class="empty">{{ 'pages.dozenten.empty' | translate }}</p>
        </ng-template>
      </nb-card-body>
    </nb-card>

    <!-- Right: detail of selected dozent -->
    <nb-card class="detail-card" *ngIf="selectedDozent as d">
      <nb-card-header>
        <h4>{{ d.name }}</h4>
        <p *ngIf="d.description" class="detail-desc">{{ d.description }}</p>
      </nb-card-header>
      <nb-card-body>
        <section class="detail-section">
          <h5>{{ 'pages.dozenten.linkedTutors' | translate }}</h5>
          <p class="hint">{{ 'pages.dozenten.linkedTutorsHint' | translate }}</p>

          <div *ngIf="tutorCandidates.length === 0" class="empty">
            {{ 'pages.dozenten.noTutorCandidates' | translate }}
          </div>

          <ul class="tutor-list">
            <li
              *ngFor="let t of tutorCandidates"
              [class.is-disabled]="isTutorLinkedToOther(t.id)"
            >
              <nb-checkbox
                [checked]="isTutorLinkedToSelected(t.id)"
                [disabled]="isTutorLinkedToOther(t.id)"
                (checkedChange)="toggleTutorLink(t)"
              >
                <span class="tutor-list__name">{{ t.name }}</span>
                <small *ngIf="isTutorLinkedToOther(t.id)" class="tutor-list__hint">
                  {{ 'pages.dozenten.linkedToOther' | translate }}
                </small>
              </nb-checkbox>
            </li>
          </ul>
        </section>

        <section class="detail-section">
          <h5>{{ 'pages.dozenten.editSettings' | translate }}</h5>
          <p class="hint">{{ 'pages.dozenten.editSettingsHint' | translate }}</p>
          <a
            nbButton
            status="basic"
            size="small"
            [routerLink]="['/tutors', d.id, 'ai-settings']"
          >
            {{ 'pages.dozenten.openAiConfig' | translate }}
          </a>
        </section>
      </nb-card-body>
    </nb-card>

    <nb-card class="detail-card" *ngIf="!selectedDozent">
      <nb-card-body class="empty">
        {{ 'pages.dozenten.selectHint' | translate }}
      </nb-card-body>
    </nb-card>
  </div>
</div>
